export const TYPING_CHAT_DIRECT_MESSAGE = 'TypingChatDirectMessage';
// new direct messages
export const NEW_OUTGOING_CHAT_DIRECT_MESSAGE =
  'NewOutgoingChatDirectMessage';
export const NEW_INCOMING_CHAT_DIRECT_MESSAGE =
  'NewIncomingChatDirectMessage';
export const SUCCESS_OUTGOING_CHAT_DIRECT_MESSAGE =
  'SuccessOutgoingChatDirectMessage';
export const ERROR_OUTGOING_CHAT_DIRECT_MESSAGE =
  'ErrorOutgoingChatDirectMessage';

// get chat direct messages
export const GET_CHAT_DIRECT_MESSAGES = 'GetChatDirectMessages';
export const GET_CHAT_DIRECT_MESSAGES_SUCCESS =
  'GetChatDirectMessagesSuccess';
export const GET_CHAT_DIRECT_MESSAGES_ERROR =
  'GetChatDirectMessagesError';
